export default __webpack_public_path__ + "static/media/error-modal-header.17d9d0bb.png";